<div class="content-box task">
  <div class="title-cancel">
    <div class="header-task">
      <h3>Dashboard</h3>
    </div>

    <div class="header-task">
      <i class="button-icon fas fa-xmark fa-xl cursor-pointer" (click)="closeSideBar()"></i>
    </div>
  </div>

  <div class="form-infos">
    <div class="dashboard-box">
      <div *ngIf="loadingPie" class="loading-dash">
        <img class="loading-graph" src="assets/loading-graphs.gif" />
      </div>
      <span class="dashboard-card-title">Sinalizações HVD</span>
      <div *ngIf="!loadingPie" id="chartPie"></div>
    </div>

    <div class="chartScrollHorizontal dashboard-box">
      <div *ngIf="loadingBar" class="loading-dash">
        <img class="loading-graph" src="assets/loading-graphs.gif" />
      </div>
      <span class="dashboard-card-title">Cadastradas por região</span>
      <div *ngIf="!loadingBar" id="chartBar"></div>
    </div>

    <div class="dashboard-box">
      <div *ngIf="loadingTreemap" class="loading-dash">
        <img class="loading-graph" src="assets/loading-graphs.gif" />
      </div>
      <span class="dashboard-card-title">Tarefas do dia</span>
      <div *ngIf="!loadingTreemap" id="chartTreemap"></div>
    </div>
  </div>
</div>
